import * as types from '../types/assignations'
import createReducer from '../createReducer'

const initAssignationsState = {}

export default createReducer(initAssignationsState, {
  [types.UPDATE_EXISTING_ASSIGNATION](state, action) {
    const newAssignations = state
    newAssignations[action.assignation._id] = action.assignation
    return Object.assign({}, state, newAssignations)
  },
  [types.SET_ALL_ASSIGNATIONS](state, action) {
    return Object.assign({}, action.assignations)
  },
  [types.ADD_NEW_ASSIGNATION](state, action) {
    return Object.assign({}, state, { [action.assignation._id]: action.assignation })
  },
  [types.DELETE_ASSIGNATION](state, action) {
    const newState = state
    delete newState[action.assignation._id]
    return newState
  },
})
